import { render, staticRenderFns } from "./Create-Company-Equipment.vue?vue&type=template&id=05b1884a&scoped=true"
import script from "./Create-Company-Equipment.vue?vue&type=script&lang=js"
export * from "./Create-Company-Equipment.vue?vue&type=script&lang=js"
import style0 from "./Create-Company-Equipment.vue?vue&type=style&index=0&id=05b1884a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b1884a",
  null
  
)

export default component.exports